import styles from "./styles.module.scss";

import { IconCard } from "../../../../shared";

import { useState } from "react";
import { Button } from "../../../../../../common";

import full_empty from "./img/full_empty.png";

import lower_back from "./img/lower_back.png";
import belly from "./img/belly.png";
import buttocks from "./img/buttocks.png";
import hips from "./img/hips.png";
import knees from "./img/knees.png";
import calves from "./img/calves.png";

import { closeModal, openModal } from "@utils/modal";
import { IconCardWalky } from "src/routes/onboarding/shared/components/iconCardWalky";

const data = [
  {
    img: lower_back,
    value: "lower_back",
    displayValue: "Lower back",
  },
  {
    img: belly,
    value: "belly",
    displayValue: "Belly",
  },
  {
    img: buttocks,
    value: "buttocks",
    displayValue: "Buttocks",
  },

  {
    img: hips,
    value: "hips",
    displayValue: "Hips",
  },
  {
    img: knees,
    value: "knees",
    displayValue: "Knees",
  },
  {
    img: calves,
    value: "calves",
    displayValue: "Calves",
  },
];
export const ChooseTargetZones = ({ onNextStep, onTrackEvent }) => {
  const [checked, setChecked] = useState([]);

  const handleCheck = (value) => {
    setChecked((prevState) => {
      if (prevState.includes(value)) {
        return prevState.filter((item) => item !== value);
      }
      return [...prevState, value];
    });
  };

  const handleNextStep = () => {
    const dataToSend = checked.length === data.length ? "Full body" : checked;
    console.log(dataToSend);
    closeModal();
    onNextStep(dataToSend);
    onTrackEvent(dataToSend);
  };

  const handleCheckAll = () => {
    if (checked.length === data.length) {
      setChecked([]);
      return;
    }
    setChecked(data.map((i) => i.value));
  };

  const handleOpenModal = () => {
    openModal(
      <div className={styles.modal}>
        <h5>Plan adjusted!</h5>
        <p>
          You'll still get a full-body workout, but we'll focus more on the
          areas you've chosen.
        </p>
        <Button variant='walky' onClick={handleNextStep}>GOT IT</Button>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>Choose your target zones</h2>
        <div className={styles.cardsWithImage}>
          <div className={styles.cards}>
            {data.map((value) => (
              <IconCardWalky
                active={checked.includes(value.value)}
                onClick={() => handleCheck(value.value)}
                title={value.displayValue}
                key={value.value}
              />
            ))}
            <IconCardWalky
              active={checked.length === data.length}
              onClick={handleCheckAll}
              title={"Full body"}
            />
          </div>
          <div className={styles.targetZonesContainer}>
            <img src={full_empty} alt="img" />
            {data.map(
              ({ img, value }) =>
                checked.includes(value) && (
                  <img
                    className={styles.targetZoneImage}
                    src={img}
                    alt={value}
                    key={value}
                  />
                )
            )}
          </div>
        </div>
      </div>
      <div className={styles.action}>
        <Button
          variant="walky"
          disabled={!checked.length}
          onClick={handleOpenModal}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};
